import { render, staticRenderFns } from "./ajout-culture.vue?vue&type=template&id=2aaa0cab&scoped=true"
import script from "./ajout-culture.vue?vue&type=script&lang=js"
export * from "./ajout-culture.vue?vue&type=script&lang=js"
import style0 from "./ajout-culture.vue?vue&type=style&index=0&id=2aaa0cab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aaa0cab",
  null
  
)

export default component.exports